<template>
  <l-layout :layout="['xs12']">
  <l-cache :get-data="getInstitution" :id="$route.query.id" ref="cache">
    <template slot-scope="{data}">
      <v-card>
        <v-card-title style="height: 64px">
          <span class="title pl-2">{{data.name}}</span>
          <v-layout class="pl-4" wrap>
            <v-flex xs6>
              <span class="grey--text caption mr-2">创建时间</span>
              <span class="pr-4">{{$L.time.stringify(data.creationTime) || 'N/A'}}</span>
            </v-flex>
            <v-flex xs6>
              <span class="grey--text caption mr-2">上次更新</span>
              <span class="pr-4">{{$L.time.stringify(data.lastUpdateTime) || 'N/A'}}</span>
            </v-flex>
          </v-layout>
          <v-spacer></v-spacer>
          <v-btn @click="goEdit()" color="primary" flat small>编辑</v-btn>
          <v-btn @click="$refs.cache.retry()" color="primary" flat small>刷新</v-btn>
        </v-card-title>
        <v-card-text>
          <v-container class="py-0" fluid grid-list-md>
            <v-layout class="mb-4" wrap>
              <v-flex xs12 sm8>
                <v-text-field
                  disabled
                  label="机构名称"
                  placeholder="N/A"
                  prepend-icon="$vuetify.icons.institution"
                  v-model="data.name"
                ></v-text-field>
              </v-flex>
              <v-flex sm4 xs12>
                <v-text-field
                  disabled
                  label="机构代码"
                  placeholder="N/A"
                  prepend-icon="$vuetify.icons.levelCode"
                  v-model="data.code"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  :rows="1"
                  auto-grow
                  disabled
                  placeholder="N/A"
                  label="机构描述"
                  prepend-icon="$vuetify.icons.description"
                  v-model="data.description"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout>
              <l-select-file
                :dialog-props="apkProps"
                :hint="'仅支持.apk文件'"
                @cancel="apkProps.activate = false"
                @submit="uploadApk"
                select-type="dialog"
              >
                <v-btn class="mx-0" color="primary" flat  :loading="loading"
                       slot="activator">上传APK
                </v-btn>
              </l-select-file>
            </v-layout>
            <v-layout>
              <v-text-field label="版本号" v-model="version"></v-text-field>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </template>
  </l-cache>
  </l-layout>
</template>

<script>
export default {
  name: 'InstitutionDetails',
  data(){
    return {
      apkProps: {
        activate: true,
        autoClose: true,
        title: '上传APK'
      },
      loading:false,
      version:"1.0.3"
    }
  },
  methods: {
    async getInstitution () {
      let {items} = await this.$store.dispatch('userAdmin/getInstitutions', {
        pagination: {},
        filter: [{key: 'id', value: this.$route.query.id}]
      })
      if (items && items.length > 0) {
        let p = items[0]
        return p
      }
      else {
        throw Error('未找到该机构')
      }
    },
    goEdit () {
      this.$store.dispatch('L/routerInTab').then(() => {
        this.$router.replace({
          name: 'EditInstitution',
          params: this.$route.params,
          query: this.$route.query
        })
      })
    },
    async uploadApk (files) {
      let f = files[0]
      console.log(f)
      let formData = new FormData()
      formData.append('file', f)
      this.loading = true
      try{
        let res = await this.$store.dispatch('userAdmin/uploadApk', {formData:formData,version:this.version})
        this.loading = false
        console.log(res)
        if (res.data.status + '' === '1') {
          this.$L.alert('success', {message: '上传成功'})
        }
        else {
          this.$L.alert('error', {message: '上传失败，原因:' + res.data.msg})
        }
      }catch (e) {
        this.loading = false

      }
    },
  }
}
</script>

<style scoped>

</style>
